module.exports = __webpack_public_path__ + "static/media/chatReplying.2461ee78.gif";